/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_NewInputs */

const en_jobs_new = /** @type {(inputs: Jobs_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New job`)
};

const he_jobs_new = /** @type {(inputs: Jobs_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`משימה חדשה`)
};

/**
* | output |
* | --- |
* | "New job" |
*
* @param {Jobs_NewInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_new = /** @type {((inputs?: Jobs_NewInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_NewInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_new(inputs)
	return he_jobs_new(inputs)
});